module.exports = __webpack_public_path__ + "img/banner.64a7cc8e.png";